import Slider from "react-slick";
import { Link } from "react-router-dom";

import { DATA } from '../../data.js'
import HomeIcon from '../../assets/home-icon.png';
import SurfaceIcon from '../../assets/surface-icon.png';

import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";
import { ImageSlider, DataSlider, DataSliderList, SliderHomeIcon } from './carousel.styles.jsx'
import './carousel.styles.scss'

const CarouselHome = () => {
  var settings = {
    autoplay: true,
    arrows: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Slider {...settings}>
      {DATA.map((data) => (
        data.items.map((items) => (
          <div key={items.id}>
            {/* <Link to={`estate/${items.id}`}>
              <ImageSlider style={{backgroundImage: `url('${items.imageUrl}')`}} />
            </Link> */}
            <Link>
              <ImageSlider style={{backgroundImage: `url('${items.imageUrl}')`}} />
            </Link>
            <DataSlider>
              <li className="DataSliderPrice">{items.price}</li>
              <DataSliderList>  
                <li>{items.size}</li>
                <li>{items.rooms}</li>

                {/* <SliderHomeIcon
                  src={data.title === 'Casas' ? HomeIcon : SurfaceIcon}
                  alt='home-icon'
                /> */}
              </DataSliderList>
              <li className="DataSliderName">{items.name}</li>
            </DataSlider>
          </div>
        ))
      ))}
    </Slider>
  )
}

export default CarouselHome;